import * as React from 'react'
import Dropzone from 'react-dropzone'
import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import { observer } from 'mobx-react'

import { Authorized } from 'modules/core/components/Authorized'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import FileList from 'modules/documents/components/FileList'
import type { EmployeeImporterContextProps } from 'modules/employees/lib/employeesImporterContext'

import styles from './index.module.css'

type DropzoneProps = React.ComponentProps<typeof Dropzone>

interface DropZoneProps {
  onDropFile: DropzoneProps['onDrop']
}

const DropZone = ({ onDropFile }: DropZoneProps) => {
  const {
    company: { subscription },
  } = useCurrentSession()

  return (
    <Authorized subscription={subscription}>
      <Dropzone onDrop={onDropFile} multiple={false}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <div
            {...getRootProps()}
            className={`${styles.uploader} ${isDragActive && styles.uploaderActive}`}
          >
            <input {...getInputProps()} />
            <img className={styles.clouds} src={clouds} />
            <div className={styles.text}>
              {i18n.tView('import.drop_explanation', {
                browse: <span className={styles.browse}>{i18n.t('import.browse')} </span>,
              })}
            </div>
          </div>
        )}
      </Dropzone>
    </Authorized>
  )
}

interface Props {
  importer: EmployeeImporterContextProps
  openModalOnDrop?: boolean
}

const EmployeesFileImporter = ({ importer, openModalOnDrop = false }: Props) => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const onDropFile = (filesOnDrop: File[]) => {
    if (openModalOnDrop) {
      navigate(navigation.employees.list.import.fullPath())
    }

    importer.setFiles(filesOnDrop)
  }

  const onDeleteFile = () => {
    importer.setFiles([])
  }

  if (openModalOnDrop) return <DropZone onDropFile={onDropFile} />

  return (
    <>
      <DropZone onDropFile={onDropFile} />
      {importer.hasFile && (
        <Box paddingTop="s24">
          <FileList files={importer.files} onDeleteFile={onDeleteFile} spaced={false} />
        </Box>
      )}
    </>
  )
}

export default observer(EmployeesFileImporter)
